/* eslint-disable no-console */
export const runCacheBusterDiagnostics = (opts: { currentVersion: string; isLocalEnv: boolean; basePath?: string }) => {
  const rawBase = opts.isLocalEnv ? '' : opts.basePath || process.env.PUBLIC_URL || '/portal/app';

  const base = (rawBase || '').replace(/\/$/, '');
  const metaUrl = `${base || ''}/meta.json`;

  const shouldLog = new URLSearchParams(globalThis.location.search).get('diagnose') === '1';

  if (!shouldLog) return;

  fetch(metaUrl, { cache: 'no-store' })
    .then(async (res) => {
      let body = null;
      let text: string | null = null;

      try {
        body = await res.clone().json();
      } catch {
        text = await res.text();
      }

      if (!body) {
        console.warn('meta.json is not valid JSON. First 50 chars:', (text || '').slice(0, 50));
        return;
      }

      const serverVersion = String(body.version ?? '');
      const bundleVersion = String(opts.currentVersion ?? '');

      console.log('Bundle version:', bundleVersion);
      console.log('Server version:', serverVersion);
    })
    .catch((err) => {
      console.error('Failed to fetch meta.json at', metaUrl, err);
    });
};
